import { io } from 'socket.io-client';
import { SocketUrl } from 'environment';

let socket;

export const initSocket = () => {
  const token = localStorage.getItem('token');

  socket = io(SocketUrl, {
    auth: {
      token: `Bearer ${token}`,
    },
    autoConnect: true,
  });

  return socket;
};

export const getSocket = () => socket;